import * as Yup from 'yup';

export const equipmentCategoryListSchema = Yup.object({
  Description: Yup.string().required('Category is required'),
});
